import { useCallback, useEffect, useState } from "react";

import ProcessusService from "../../../services/smq/ProcessusService";

let categoriesCache = [];
let categoriesError = null;
let categoriesInitialized = false;
let categoriesLoading = false;
let categoriesRequest = null;

const subscribers = new Set();

const getCategoriesSnapshot = () => ({
  categories: categoriesCache,
  categoriesError,
  categoriesLoading: categoriesLoading || !categoriesInitialized,
});

const notifySubscribers = () => {
  const snapshot = getCategoriesSnapshot();
  subscribers.forEach((subscriber) => subscriber(snapshot));
};

const getErrorMessage = (error) =>
  error?.message || "Impossible de charger les catégories de processus";

const loadCategories = (forceRefresh = false) => {
  if (categoriesRequest) {
    return categoriesRequest;
  }

  if (categoriesInitialized && !forceRefresh) {
    return Promise.resolve(categoriesCache);
  }

  categoriesLoading = true;
  categoriesError = null;
  notifySubscribers();

  categoriesRequest = ProcessusService.getCategories()
    .then((payload) => {
      if (!Array.isArray(payload?.data)) {
        throw new Error(
          "Le service des catégories a retourné une réponse invalide"
        );
      }

      categoriesCache = payload.data;
      categoriesError = null;
      return categoriesCache;
    })
    .catch((error) => {
      categoriesError = getErrorMessage(error);
      throw error;
    })
    .finally(() => {
      categoriesInitialized = true;
      categoriesLoading = false;
      categoriesRequest = null;
      notifySubscribers();
    });

  return categoriesRequest;
};

const useParameter = () => {
  const [categoryState, setCategoryState] = useState(
    getCategoriesSnapshot
  );

  useEffect(() => {
    subscribers.add(setCategoryState);
    setCategoryState(getCategoriesSnapshot());
    loadCategories().catch(() => undefined);

    return () => {
      subscribers.delete(setCategoryState);
    };
  }, []);

  const refreshCategories = useCallback(() => loadCategories(true), []);

  return {
    categories: categoryState.categories,
    categoriesError: categoryState.categoriesError,
    categoriesLoading: categoryState.categoriesLoading,
    refreshCategories,
  };
};

export default useParameter;
